// extracted by mini-css-extract-plugin
export default {"comment-content":"Comments_comment-content__GIoqy","isEmpty":"Comments_isEmpty__xwCap"};